<template>
  <div class="logo-material">
    <img src="@/assets/logo_engemini.svg" style="max-width: 750px; min-width: 320px;">
  </div>
  <div>
    <NameMaterial @name="materialNameComponent($event)"/>
    <div class="table-mesure">
      <div class="unique-table">
        <TableMesure name_table="Density" unityName="Density" unity="[kg/m2]" @datas="tableDatas('density_', $event)"
                     ref="clearAll1"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Thermal conductivity" unityName="Thermal conductivity" unity="[W/(m.K)]"
                     @datas="tableDatas('thermal_', $event)" ref="clearAll2"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Heat capacity" unityName="Heat capacity" unity="[J/(kg.K)]"
                     @datas="tableDatas('heat_', $event)" ref="clearAll3"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Coefficient of thermal expansion" unityName="Coefficient of thermal expansion"
                     unity="[1/K]" @datas="tableDatas('coefficient_', $event)" ref="clearAll4"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Electrical conductivity" unityName="Electrical conductivity" unity="[S/m]"
                     @datas="tableDatas('electrical_', $event)" ref="clearAll5"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Young’s modulus" unityName="Young's modulus" unity="[GPa]"
                     @datas="tableDatas('young_modulus_', $event)" ref="clearAll6"/>
      </div>
      <div class="unique-table">
        <TableMesure name_table="Poisson’s ratio" unityName="Poisson's ratio" unity="[1]"
                     @datas="tableDatas('poisson_', $event)" ref="clearAll7"/>
      </div>
      <div class="button-table">
        <Button style="margin: 1rem; height: 3rem;" label="Clear all" @click="clearAll"/>
        <FileUpload name="plop[]" mode="basic" style="margin: 1rem; height: 3rem;"
                    :chooseLabel="'Add to existing \n material library'"
                    accept=".csv" :customUpload="true" @uploader="myUploader" :auto="true" :showUploadButton="false"
                    :showCancelButton="false"/>
        <Button style="margin: 1rem; height: 3rem;" label="Create a new material library" @click="newCsv"/>
      </div>
    </div>
  </div>
</template>

<script>
import NameMaterial from "@/components/name_material";
import TableMesure from "@/components/table_component.vue";

export default {
  name: 'App',
  components: {
    NameMaterial,
    TableMesure,
  },
  data() {
    return {
      fullData: {},
      materialName: '',
      filename: '',
      control: true
    }
  },
  methods: {
    controlsEmpty() {
      let ctrl = true
      this.control = true
      if (this.materialName === '') {
        this.control = false
      }
      ctrl = this.$refs.clearAll1.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll2.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll3.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll4.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll5.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll6.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      ctrl = this.$refs.clearAll7.controlEmpty()
      if (ctrl === false) {
        this.control = false
      }
      return this.control
    },
    async myUploader(event) {
      this.filename = event.files[0].name
      let test = await event.files[0].text()
      test = test.slice(0, -2)
      localStorage.removeItem('csv')
      localStorage.setItem('csv', test)
      this.newCsv(false)
    },
    newCsv(newFile = true) {
      this.controlsEmpty()
      if (this.control === false) {
        return
      }
      if (newFile) {
        localStorage.removeItem('csv')
      }
      const informations = this.extractInformations(this.fullData);
      const csvPart = this.generateCSVPart(informations);
      this.appendToExistingCSV(csvPart);

      let blob = new Blob(["\uFEFF"+localStorage.getItem('csv')+"\r\n"], {type: 'text/csv; charset=UTF-8'})
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = blobUrl
      link.download = newFile ? 'material.csv' : this.filename
      link.click()
    },
    /**
     * Extract informations from given data
     * @param data data to parse
     * @returns material informations
     */
    extractInformations(data) {
      const informations = [];
      for (let [characteristicName, valuesMap] of Object.entries(data)) {
        // Keep characteristic name
        const characteristic = {name: `${characteristicName}${this.materialName}`};

        // Keep property values and line count
        characteristic.lines = Object.values(valuesMap).map(values => Object.values(values));
        characteristic.lineCount = characteristic.lines.length;

        // Push informations into result array
        informations.push(characteristic);
      }
      return informations;
    },
    /**
     * Generate CSV part from given informations
     * @param informations material informations
     * @returns CSV part
     */
    generateCSVPart(informations) {
      // Construct header (characteristic name and line count)
      const header = informations.map(characteristic => `${characteristic.name},${characteristic.lineCount},`).join(',');

      // Compute max line count
      let maxLineCount = 0;
      informations.forEach(characteristic => maxLineCount = Math.max(characteristic.lineCount, maxLineCount));

      // Construct lines containing values
      const lines = [];
      for (let lineIndex = 0; lineIndex < maxLineCount; lineIndex++) {
        const line = [];
        informations.forEach(characteristic => {
          if (characteristic.lines.length > lineIndex) {
            const values = characteristic.lines[lineIndex];
            line.push(values.length === 3 ? values.join(',') : `0,100,${values[0]}`);
          } else line.push(',,');
        });
        lines.push(line.join(','));
      }
      const csvPart = `${header}\r\n${lines.join('\r\n')}`;
      return csvPart;
    },
    /**
     * Append given CSV part to existing CSV in local storage
     * @param csvPart CSV part to add
     */
    appendToExistingCSV(csvPart) {
      // Get existing csv from local storage
      let csv = localStorage.getItem('csv');
      if (csv) {
        // Get first line
        let [firstLine, ...otherLines] = csv.split('\r\n');

        // Update the first line
        const firstLineArray = firstLine.split(',');
        firstLineArray[0]++;
        firstLineArray[firstLineArray[0]] = this.materialName;
        const header = firstLineArray.join(',');

        // Regenerate csv
        csv = `${header}\r\n${otherLines.join('\r\n')}\r\n${csvPart}`;
      } else {
        // Generate a new csv
        const columnCount = csvPart.split('\r\n')[0].split(',').length;
        const header = [1, this.materialName, ...(new Array(columnCount - 2))].join(',');
        csv = `${header}\r\n${csvPart}`;
      }
      localStorage.setItem('csv', csv);
    },
    materialNameComponent(name) {
      this.materialName = name
    },
    clearAll() {
      this.$refs.clearAll1.clearAll()
      this.$refs.clearAll2.clearAll()
      this.$refs.clearAll3.clearAll()
      this.$refs.clearAll4.clearAll()
      this.$refs.clearAll5.clearAll()
      this.$refs.clearAll6.clearAll()
      this.$refs.clearAll7.clearAll()
      this.fullData = {}
    },
    tableDatas(nameTable, datas) {
      this.fullData[nameTable] = datas
    }
  }
}
</script>

<style>
body {
  font-size: 80%;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px !important;
}

.logo-material {
  margin: -2rem 0 7rem 0;
}

.table-mesure {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

.unique-table {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  margin: 0;
  padding: 1rem;
  width: 774px;
}

.button-table {
  display: flex;
  flex-direction: row;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  margin: 0;
  padding: 3rem 2.5rem;
  width: 774px;
}
</style>
